export const path = {
  FINANCIAL_FORECAST: "/financial-forecast",
  FINANCIAL_FORECAST_COMPANY_DETAILS: "/financial-forecast/company-details",
  FINANCIAL_FORECAST_ASSUMPTIONS: "/financial-forecast/assumptions",
  FINANCIAL_FORECAST_SUBSCRIBER_CQUISITIONS:
    "/financial-forecast/subscriber-cquisitions",
  FINANCIAL_FORECAST_REVENUE: "/financial-forecast/revenue",
  FINANCIAL_FORECAST_COST_AND_EXPENSES: "/financial-forecast/cost_and_expenses",
  FINANCIAL_FORECAST_HIRING_PLAN: "/financial-forecast/hiring_plan",
  FINANCIAL_FORECAST_PROFIT_LOSS: "/financial-forecast/profit_loss",
  FINANCIAL_FORECAST_FREECASH_FLOW: "/financial-forecast/freecash_flow",
  // PERFORMANCE_ANALYSIS: "/performance-analysis",
  SAAS_SUBSCRIPTION_FEE_CALCULATOR: "/calculators/saas-subscription-fee",
  EMERGENCY_FUND_CALCULATOR: "/calculators/emergency-fund",
  CASH_RUNWAY_CALCULATORS: "/calculators/cash-runway",
  CUSTOMIZATION: "/customization",
};

export const defaultPath = {
  FINANCIAL_FORECAST: path.FINANCIAL_FORECAST_FREECASH_FLOW,
  // PERFORMANCE_ANALYSIS: path.PERFORMANCE_ANALYSIS,
  CALCULATORS: path.SAAS_SUBSCRIPTION_FEE_CALCULATOR,
};
export const mainPages = {
  FINANCIAL_FORECAST: "financial-forecast",
  // PERFORMANCE_ANALYSIS: "performance analysis",
  CALCULATORS: "Calculators",
  CUSTOMIZE: "Customize",
};
